import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ModulesProvider } from './context/ModulesContext';
import { AppThemeProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import { ConfirmProvider } from './components/ui';
import reportWebVitals from './reportWebVitals';
import { installToastDedup } from './utils/toastConfig';
import { restoreAuth, persistAuth } from './utils/authPersist';
//import { registerServiceWorker } from './pwa';

installToastDedup();

// Restore a persisted login (localStorage → sessionStorage) BEFORE the app reads
// the token, so users stay logged in across browser restarts instead of having
// to sign in every time the browser is closed and reopened.
restoreAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <AuthProvider>
        <ModulesProvider>
          <NotificationProvider>
            <ConfirmProvider>
              <App />
              <ToastContainer position="top-right" autoClose={4000} newestOnTop pauseOnHover theme="colored" limit={4} />
            </ConfirmProvider>
          </NotificationProvider>
        </ModulesProvider>
      </AuthProvider>
    </AppThemeProvider>
  </React.StrictMode>
);

reportWebVitals();

// Persist the session into localStorage when the tab is hidden or closed, so the
// login is still there on the next browser launch.
window.addEventListener('pagehide', persistAuth);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') persistAuth();
});
//registerServiceWorker();

// Service worker strategy after the zombie-cache incident:
// - /push-worker.js is a PUSH-ONLY worker (no fetch handler, no caching) so
//   deploys always arrive. Registering it at scope "/" REPLACES any legacy
//   cache-first worker still lingering in a browser, and its activate step
//   wipes leftover caches.
// - Browsers without Push support just get all workers unregistered (the old
//   kill-switch behaviour).
if ("serviceWorker" in navigator) {
  if ("PushManager" in window) {
    navigator.serviceWorker.register("/push-worker.js").catch(() => {});
  } else {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }
}
